import spacings from 'shared-tokens/utils/tokens/spacings';

export const mainCls = 'list-checkbox';
export const clsItem = `${mainCls}__item`;
export const clsNested = `${mainCls}--nested`;

const border = '1px solid #d8dbdf';

export default {
  [mainCls]: {

  },
  [clsItem]: {
    borderTop: border,

    '&:last-child': {
      borderBottom: border,
    }
  },
  [clsNested]: {
    marginRight: spacings.lx,
    marginLeft: spacings.lx,

    [`& .${clsItem}`]: {
      borderTopStyle: 'dashed',

      '&:last-child': {
        borderBottom: 'none',
      }
    },

    [`& .list-chk-item__grid-label`]: {
      paddingLeft: 0,
      paddingRight: 0,
    }
  },
};
